import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { LoggerService } from 'src/app/core/logger.service';
import { DatosService } from 'src/app/services/datos.service';
import { AdministracionService } from 'src/data/services/admin/administracion.service';

@Component({
    selector: 'app-channel-list',
    templateUrl: './channel-list.component.html',
    styleUrls: ['./channel-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChannelListComponent {

  items: any[] = [];
  filteredItems: any[] = [];
  
  constructor(private administracionService: AdministracionService, private router: Router, private datosService: DatosService, private logger: LoggerService) { }


   ngOnInit(): void {
    this.administracionService.getChannels().pipe(
      switchMap((response) => {
        this.items = response.data;
        const requests = this.items.map(item => 
          this.administracionService.getUserByChannel(item.id)
        );
        return forkJoin(requests);
      })
    ).subscribe((responses) => {
      responses.forEach((responseUsers, index) => {
        this.logger.debug(`Usuarios del canal ${this.items[index].id}:`, responseUsers.data.length);
        this.items[index].usuarios = responseUsers.data;
        this.logger.debug("CANAL:");
        this.logger.debug(this.items[index]);
      });
      this.filteredItems = this.items;
    }, (error) => {
      console.error('Error obteniendo los usuarios por canal', error);
    });

    this.logger.debug("Listo los canales con sus usuarios");
    this.logger.debug(this.items);
  }

  getCircleColor(estado: boolean) {
    switch (estado) {
      case true:
        return '#cff892';
      case false:
        return '#fe0002';
      default:
        return '#fe0002';
    }
  }

  verDatos(item: any) {
    this.logger.debug('Ver datos clicado del item:' + item.name);
    this.router.navigateByUrl('channelDetail', { state: { canal: item } });
  }

  editarDatos(item : any) {
    this.logger.debug('Editar datos clicado del item:' + item.name);
  }

  eliminarDatos(item: any) {
    this.logger.debug('Eliminar datos clicado del item:' + item.name);
  }

  filterItems(event: any) {
    const query = event.target.value.toLowerCase();
    this.filteredItems = this.items.filter(item => item.name.toLowerCase().includes(query));
  }

}
